export const enquiryStatusOptions = [
	{ label: "Pending", value: "pending" },
	{ label: "Processed", value: "processed" },
];
